import $ from "jquery";
import "slick-carousel";

class Slick {
    run() {
        this.carousel();
    }

    carousel() {
        $('#who .gallery').slick({
            mobileFirst: true,
            dots: false,
            arrows: false,
            infinite: true,
            autoplay: true,
            speed: 700,
            centerMode: true,
            slidesToShow: 1,
            draggable: true,
            responsive: [
                {
                    breakpoint: 786,
                    settings: "unslick"
                }
            ]
        });
    }
}


const slick = new Slick();
export default slick;
